// GSAP hook for the illustrations. Off for now, so the bundle stays as it is and the CSS keyframes run.
// To switch on: `npm i gsap`, then make this
//   export async function loadGsap() {
//     const { gsap } = await import(/* webpackChunkName: "gsap" */ 'gsap');
//     return gsap;
//   }
// It is only loaded when a scene first scrolls into view. Every scene keeps a matching *.timeline.js.
export async function loadGsap() {
  return null;
}
